import React from "react";
import { RegisterLayout } from "./RegisterLayout";

export const Registered = ({}) => {
  return <RegisterLayout registered />;
};
